import { VisitPatient } from '@dreryk/egabinet-visit-frontend-api';
import { EducationalMaterial } from '@dreryk/egabinet-knowledge-base-frontend-api';

import {
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalWidth,
   ShowModalEventInterceptor,
   StyledFlex,
   ValidateFormEventInterceptor,
} from '@dreryk/react-components';

import { VisitId } from '~libs.shared.visit';

import { educationalMaterialsTranslationKeys as t } from '../translations';
import { EducationalMaterialRemoveHandler } from '../table/EducationalMaterialsTable.types';

import { EducationalMaterialShareForm } from './EducationalMaterialShareForm';
import { EducationalMaterialShareEventInterceptor } from './EducationalMaterialShareEventInterceptor';
import { EducationalMaterialShareFormTable } from './EducationalMaterialShareFormTable';

type EducationalMaterialShareShowModalInterceptorProps = Readonly<{
   children: JSX.Element;
   visitId: VisitId;
   patientEmail: VisitPatient['emailAddress'];
   educationalMaterials: EducationalMaterial[];
   onEducationalMaterialRemoved?: EducationalMaterialRemoveHandler;
   onEducationalMaterialsShareSuccess?: VoidFunction;
}>;

export const EducationalMaterialShareShowModalInterceptor = (
   props: EducationalMaterialShareShowModalInterceptorProps
): JSX.Element => {
   return (
      <ShowModalEventInterceptor
         testId={'shareEducationalMaterials'}
         title={t.share.shareEducationalMaterialsWithPatient}
         content={({ resolve, reject, closeModal }) => (
            <StyledFlex gap={'18px'} direction={'column'}>
               <EducationalMaterialShareFormTable
                  educationalMaterials={props.educationalMaterials}
                  onEducationalMaterialRemoved={props.onEducationalMaterialRemoved}
                  closeModal={closeModal}
               />
               <EducationalMaterialShareForm patientEmail={props.patientEmail}>
                  {({ trigger, handleSubmit: handleEducationalMaterialShareSubmit }) => (
                     <ValidateFormEventInterceptor trigger={trigger}>
                        <EducationalMaterialShareEventInterceptor
                           patientEmail={props.patientEmail}
                           visitId={props.visitId}
                           educationalMaterials={props.educationalMaterials}
                           onEducationalMaterialShareFormSubmit={handleEducationalMaterialShareSubmit}
                           onEducationalMaterialsShareSuccess={props.onEducationalMaterialsShareSuccess}
                        >
                           <ModalConfirmButton label={t.share.send} onClick={resolve} />
                        </EducationalMaterialShareEventInterceptor>
                     </ValidateFormEventInterceptor>
                  )}
               </EducationalMaterialShareForm>

               <ModalCancelButton label={t.share.cancel} onClick={reject} />
               <ModalCloseButton onClick={reject} />
            </StyledFlex>
         )}
         modalWidth={ModalWidth.NORMAL}
         shouldShowModal
         footerItemsHidden
      >
         {props.children}
      </ShowModalEventInterceptor>
   );
};
